import { SET_CLICKED_NFM, SET_COLLECTION_ITEMS, SET_STAKED_ITEMS, SET_WALLET_ADDRESS } from "../actions/WalletTypes";

const initialState = {
    walletAddress: "",
    collectionItems: [],
    stakedItems: [],
    clickedNFM: null
}


function WalletReducer(state = initialState, action) {
    switch (action.type) {
        case SET_WALLET_ADDRESS:
            return {
                ...state,
                walletAddress: action.payload || ""
            }
        
        case SET_COLLECTION_ITEMS:
            return {
                ...state,
                collectionItems: action.payload || []
            }
        
        case SET_STAKED_ITEMS:
            return {
                ...state,
                stakedItems: action.payload || []
            }
        
        case SET_CLICKED_NFM:
            return {
                ...state,
                clickedNFM: action.payload || null
            }
        default:
            return state;
    }
}

export default WalletReducer;